import React from 'react'
import {CategoryColumns} from '@/components/category-columns'
import PropTypes from 'prop-types'

const CategoryColumnsBuilder = (props) => {
    return <CategoryColumns {...props} />
}

CategoryColumnsBuilder.propTypes = {
    columnItems: PropTypes.arrayOf(
        PropTypes.shape({
            columnImage: PropTypes.string,
            external: PropTypes.bool,
            external_link: PropTypes.shape({
                id: PropTypes.string,
                value: PropTypes.shape({
                    data: PropTypes.shape({
                        isSfraPage: PropTypes.bool,
                        url: PropTypes.string
                    })
                })
            }),
            link: PropTypes.shape({
                id: PropTypes.string,
                value: PropTypes.shape({
                    data: PropTypes.shape({
                        isSfraPage: PropTypes.bool,
                        url: PropTypes.string
                    })
                })
            }),
            subtitle: PropTypes.string,
            text: PropTypes.string,
            ctaText: PropTypes.string
        })
    ),
    referenceItems: PropTypes.arrayOf(
        PropTypes.shape({
            columnData: PropTypes.shape({
                id: PropTypes.string,
                value: PropTypes.shape({
                    data: PropTypes.shape({
                        items: PropTypes.arrayOf(PropTypes.string)
                    })
                })
            })
        })
    ),
    enableReferenceData: PropTypes.bool
}

export const CategoryColumnsDefinition = {
    component: CategoryColumnsBuilder,
    name: 'CategoryColumns',
    noWrap: true,
    enrichable: true,
    enrich: true,
    inputs: [
        {
            name: 'enableReferenceData',
            type: 'boolean',
            defaultValue: false,
            required: false,
            helperText: 'Enable to use data from a category or content slot reference.'
        },
        {
            name: 'referenceItems',
            type: 'list',
            showIf: `options.get('enableReferenceData') === true`,
            subFields: [
                {
                    name: 'columnData',
                    type: 'reference',
                    model: 'category-column',
                    helperText: 'Select a category or content slot to populate the items.'
                }
            ],
            helperText: 'The array of items from the selected category or content slot.'
        },
        {
            name: 'columnItems',
            type: 'list',
            showIf: `options.get('enableReferenceData') === false`,
            subFields: [
                {
                    name: 'columnImage',
                    type: 'file',
                    helperText: 'The image for the column item.'
                },
                {
                    name: 'external',
                    type: 'boolean',
                    defaultValue: false,
                    helperText: 'Whether the link is external or internal.'
                },
                {
                    name: 'external_link',
                    type: 'reference',
                    model: 'external-links',
                    showIf: `options.get('external') === true`,
                    helperText: 'The external link for the column item.'
                },
                {
                    name: 'link',
                    type: 'reference',
                    model: 'page',
                    showIf: `options.get('external') === false`,
                    helperText: 'The internal link for the column item.'
                },
                {
                    name: 'subtitle',
                    type: 'text',
                    helperText: 'The subtitle for the column item.'
                },
                {
                    name: 'text',
                    type: 'longText',
                    helperText: 'The text for the column item.'
                },
                {
                    name: 'ctaText',
                    type: 'text',
                    helperText: 'The call to action text for the column item.'
                }
            ],
            helperText: 'The array of items to display in the category columns.'
        }
    ]
}
